import { TImageAssets } from '@/domain/Images.domain';
import { ApiUrls, URLs } from '../constants/urls';
import { DEFAULT_IMAGE_SIZES_BY_QUERIES } from '@/service/constants/variables';

type Tformats = 'jpg' | 'webp';
type TSizesByQuery = { query: string; size: string };

const FORMATS: Tformats[] = ['webp', 'jpg'];

export const createImageUrl = (id: string, size: string, type: Tformats) => {
    return `${URLs.image + ApiUrls.activity.root}/${id}/center/${size}/wr.${type}`;
};

export const createAdditionalImageUrl = (
    id: string,
    slug: string,
    size: string,
    type: Tformats
): string => {
    return `${URLs.image + ApiUrls.photo.root}/${id}/center/${size}/${slug}.${type}`;
};

export const createImagesSet = (
    images: { id: string; slug?: string }[],
    sizesByQueries = DEFAULT_IMAGE_SIZES_BY_QUERIES as TSizesByQuery[]
): TImageAssets[] => {
    return images.map(({ id, slug }: { id: string; slug?: string }) => ({
        srcSet: sizesByQueries
            .map(({ query, size }: TSizesByQuery) =>
                FORMATS.map((t) => ({
                    src: !slug
                        ? createImageUrl(id, size, t)
                        : createAdditionalImageUrl(id, slug, size, t),
                    mediaType: t === 'webp' ? 'image/webp' : 'image/jpeg',
                    media: query,
                }))
            )
            .reduce((a, b) => a.concat(b), []),
        slug,
        type: !slug ? 'activity' : 'photo',
    }));
};

export const createImageSet = (images: string[]): { srcSet: string[] }[] =>
    images?.map((i) => {
        const imgName = i?.replace(/(jpg|png|webp)/, '_format_');

        return {
            srcSet: ['webp' as Tformats, 'jpg' as Tformats].map((t) =>
                imgName?.replace('_format_', t)
            ),
        };
    });

export const createVideoSet = (videoId: string): TImageAssets[] =>
    videoId
        ? [
              {
                  srcSet: [{ src: `${ApiUrls.video.root}/${videoId}` }],
                  slug: videoId,
                  type: 'video',
              },
          ]
        : [];
